import { ElementRef, Injectable, OnDestroy, Renderer2, DOCUMENT, inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { StoreType, storeTypeNames } from './../../models/content';

@Injectable({ providedIn: 'root' })
export class ThemeService implements OnDestroy {
  private document = inject<Document>(DOCUMENT);

  private subscription: Subscription;
  private theme: BehaviorSubject<string>;

  private dagrofaStores = [StoreType.MENY, StoreType.SPAR, StoreType.MIN_KOBMAND];
  public isDagrofa: boolean;

  private onlineStores = [StoreType.GASTROLUX, StoreType.HUMOER_MOEBLER];
  public isOnline: boolean;

  constructor() {
    this.subscription = new Subscription();
    this.theme = new BehaviorSubject<string>('');
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setTheme(renderer: Renderer2, type: StoreType) {
    const typeName = storeTypeNames[type];

    const theme = `${typeName}-theme`;
    this.theme.next(theme);
    renderer.addClass(this.document.body, theme);

    this.isDagrofa = this.dagrofaStores.findIndex((s) => s === type) > -1;
    this.isOnline = this.onlineStores.findIndex((s) => s === type) > -1;
  }

  subscribeComponent(elRef: ElementRef) {
    this.subscription.add(
      this.theme.subscribe((theme) => {
        elRef.nativeElement.className += ` ${theme}`;
      }),
    );
  }
}
